import React from "react";
import Postreview from "../Components/Feed/postreview";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";

const Reviews = () => {
  return (
    <div>
      <Navbar />
      <Postreview />
      <Footer />
    </div>
  );
};

export default Reviews;
